import { render, staticRenderFns } from "./AffiliateRow.vue?vue&type=template&id=37900edd&scoped=true"
import script from "./AffiliateRow.vue?vue&type=script&lang=js"
export * from "./AffiliateRow.vue?vue&type=script&lang=js"
import style0 from "./AffiliateRow.vue?vue&type=style&index=0&id=37900edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37900edd",
  null
  
)

export default component.exports